import  type {Directive, DirectiveBinding } from 'vue';

    interface MiDirectivaIfBinding extends DirectiveBinding {
    value: boolean;
    }

    const checkPermision: Directive = {
    
        mounted(el: HTMLElement, binding: MiDirectivaIfBinding) {
            if (!binding.value) {
            el.parentNode?.removeChild(el);
            }
        },

        updated(el: HTMLElement, binding: MiDirectivaIfBinding) {
            if (!binding.value) {
            el.parentNode?.removeChild(el);
            }
        }
    
    };

export default checkPermision